import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { TestStepDetailsComponent } from "../test-step-details/test-step-details.component";
import { TestStepPictureComponent } from "../test-step-picture/test-step-picture.component";
import { TestStepRecomComponent } from '../../../step-recom/component/test-step-recom/test-step-recom.component';

@Component({
  selector: 'dpi-test-step-hub',
  imports: [MatTabsModule, TestStepDetailsComponent, TestStepPictureComponent, TestStepRecomComponent, MatBadgeModule],
  templateUrl: './test-step-hub.component.html',
  styleUrl: './test-step-hub.component.scss'
})
export class TestStepHubComponent {
  pictureNum: number;
  stepRecomNum: number;

  constructor() {
    this.pictureNum = 0;
    this.stepRecomNum = 0
  }

  setPictureNum(count: number) {
    this.pictureNum = count;
  }
  
  setStepRecomNum(count: number) {
    this.stepRecomNum = count;
  }
}
